import React, { useContext } from 'react';

// import PropTypes from 'prop-types';
import s from './ButtonPrimary.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { GradientContext } from '../../contexts/PageContexts';
import MaterialIcon from '../MaterialIcon/MaterialIcon';

const ButtonPrimary = ({
    asLink = false,
    hideStroke = false,
    children,
    disabled,
    size,
    icon,
    materialIcon = false,
    modifiers = [],
    isToggle = false,
    isActive = false,
    submit = false,
    isHovered = false,
    onLinkClick,
    isBlackIcon = false,
    isAnchor = false,
    animateIcon = true,
    ...props
}) => {
    const gradient = useContext(GradientContext);

    const isXsmall = size === 'xsmall';

    const rootClasses = classNames(
        s.Root,
        {
            [s.Disabled]: !!disabled,
            [s.Small]: size === 'small',
            [s.Xsmall]: isXsmall,
            [s.Active]: isActive,
            [s.Toggle]: isToggle,
            [s.Hover]: isHovered,
            [s.Anchor]: isAnchor,
            [s.AnimateIcon]: animateIcon,
        },
        !isToggle && s[gradient],
        modifiers.map((m) => s[m])
    );

    return asLink ? (
        <Link {...props} className={rootClasses} onClick={onLinkClick}>
            {!hideStroke && <i className={s.Bg} aria-hidden={true} />}
            {icon && (
                <span className={s.IconWrapper}>
                    <Image
                        width={22}
                        height={22}
                        src={`/img/${icon}.svg`}
                        alt=""
                        className={classNames(s.Icon, s.IconDefault)}
                    />
                    <Image
                        width={22}
                        height={22}
                        src={`/img/${icon}.svg`}
                        alt=""
                        className={classNames(s.Icon, s.IconHover)}
                    />
                </span>
            )}
            {children}
        </Link>
    ) : (
        <button type={submit ? 'submit' : 'button'} disabled={disabled} className={rootClasses} {...props}>
            {!hideStroke && <i className={s.Bg} aria-hidden={true} />}
            {icon && (
                <span
                    className={classNames(s.IconWrapper, {
                        [s['IconWrapper--XSmall']]: isXsmall,
                    })}>
                    <Image
                        width={22}
                        height={22}
                        src={`/img/${icon}.svg`}
                        alt=""
                        className={classNames(s.Icon, s.IconDefault)}
                    />
                    <Image
                        width={22}
                        height={22}
                        src={`/img/${icon}.svg`}
                        alt=""
                        className={classNames(s.Icon, s.IconHover)}
                    />
                </span>
            )}
            {materialIcon && <MaterialIcon name={materialIcon} isBlack={isBlackIcon} />}
            {children}
            {isToggle && (
                <Image width={22} height={22} src="/img/icon-chevron-down.svg" alt="" className={s.ToggleIcon} />
            )}
        </button>
    );
};

ButtonPrimary.propTypes = {};

export default ButtonPrimary;
